module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('div', {
    staticClass: "row animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('statistic.by_graph')) + "\n              ")]), _vm._v(" "), _vm._m(0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": "chart-conversion"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401f7c20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/conversions/Graph.vue
// module id = 547
// module chunks = 0